import $ from 'jquery'
import Macy from 'macy'

const macyInstances = {}
const mediaQueries = {
  xs: { min: 0, max: 479 },
  s: { min: 480, max: 639 },
  m: { min: 640, max: 1023 },
  l: { min: 1024, max: 1279 },
  xl: { min: 1230, max: 1679 },
}
let breakpoint = ''

const breakRules = {
  1: undefined,
  2: { 639: 1 },
  3: { 639: 1, 1023: 2 },
  4: { 479: 1, 1023: 2 },
  5: { 479: 1, 639: 2, 1023: 3 },
  6: { 479: 1, 639: 2, 1023: 3 },
  7: { 479: 1, 639: 2, 1023: 4 },
  8: { 479: 1, 639: 2, 1023: 4 },
}

export function init() {
  recalculateMasonry()

  // recalculate on load
  $(() => {
    recalculateMasonry()
    setTimeout(() => {
      recalculateMasonry()
    }, 500)
  })

  breakpoint = getBreakpoint($(window).width())

  $(window).on('resize', () => {
    const newBreakpoint = getBreakpoint($(window).width())
    if (newBreakpoint !== breakpoint) {
      breakpoint = newBreakpoint
      recalculateMasonry()
    }
  })
}

function getBreakpoint(windowWidth) {
  for (const key in mediaQueries) {
    if (mediaQueries[key].min <= windowWidth && mediaQueries[key].max >= windowWidth) {
      return key
    }
  }
}

export function recalculateMasonry() {
  $('[data-masonry-id]').each((i, elem) => {
    const id = $(elem).data('masonry-id')
    if (id in macyInstances) {
      macyInstances[id].resizer()
    } else {
      let columns = 1
      if ($(elem).hasClass('columns-1-2')) columns = 2
      if ($(elem).hasClass('columns-1-3')) columns = 3
      if ($(elem).hasClass('columns-1-4')) columns = 4
      if ($(elem).hasClass('columns-1-5')) columns = 5
      if ($(elem).hasClass('columns-1-6')) columns = 6
      if ($(elem).hasClass('columns-1-7')) columns = 7
      if ($(elem).hasClass('columns-1-8')) columns = 8
      const macy = new Macy({
        container: elem,
        margin: 0,
        columns,
        useOwnImageLoader: false,
        breakAt: breakRules[columns],
      })
      if (id) macyInstances[id] = macy
    }
  })
}
